import React, { useEffect, useMemo, useRef } from 'react';
import L from 'leaflet';
import { Marker, useMap } from 'react-leaflet';

const BASE_DIAMETER = 24;
const ORIGIN_DIAMETER = 12;
const BASE_ZOOM = 13;

function ConfirmedRouteTaskMarker({ marker }) {
    const map = useMap();
    const markerRef = useRef(null);
    const icon = useMemo(() => {
        const markerDiameter = marker.isRouteOrigin ? ORIGIN_DIAMETER : BASE_DIAMETER;
        const circle = document.createElement('div');
        circle.textContent = String(marker.number ?? '');
        circle.style.cssText = `
            display:flex;align-items:center;justify-content:center;
            width:${markerDiameter}px;height:${markerDiameter}px;
            box-sizing:border-box;border-radius:50%;background:${marker.isRouteOrigin ? marker.color : '#111827'};
            border:${marker.isRouteOrigin ? 2 : 1}px solid ${marker.isRouteOrigin ? '#ffffff' : 'rgba(209,213,219,0.6)'};color:#fff;
            font-weight:700;font-size:12px;line-height:1;
            transform:translate(-50%,-50%);pointer-events:none;
            transition:width 250ms ease,height 250ms ease;
        `;

        return L.divIcon({
            className: 'task-number-icon confirmed-route-task-icon',
            html: circle,
            iconSize: [0, 0],
            iconAnchor: [0, 0]
        });
    }, [marker.color, marker.isRouteOrigin, marker.number]);

    useEffect(() => {
        const resizeCircle = (event) => {
            const zoom = event?.zoom ?? map.getZoom();
            // Grow smoothly at street level, and restore the original size when zooming out.
            const baseDiameter = marker.isRouteOrigin ? ORIGIN_DIAMETER : BASE_DIAMETER;
            const diameter = baseDiameter * (1.5 ** Math.max(0, zoom - BASE_ZOOM));
            const circle = markerRef.current?.getElement()?.firstElementChild;
            if (circle) {
                circle.style.width = `${diameter}px`;
                circle.style.height = `${diameter}px`;
            }
        };

        resizeCircle();
        map.on('zoom zoomanim zoomend', resizeCircle);
        return () => map.off('zoom zoomanim zoomend', resizeCircle);
    }, [map, icon, marker.isRouteOrigin]);

    return (
        <Marker
            ref={markerRef}
            position={[marker.lat, marker.lng]}
            icon={icon}
            interactive={false}
            keyboard={false}
        />
    );
}

export default ConfirmedRouteTaskMarker;
